module.exports = __webpack_public_path__ + "img/banner.147f7009.jpg";